package com.swetdot.swetgram.data.media

import kotlinx.coroutines.flow.StateFlow

data class VoicePlaybackState(
    val messageId: String? = null,
    val isPreparing: Boolean = false,
    val isPlaying: Boolean = false,
    val positionMs: Long = 0,
    val durationMs: Long = 0,
    val speed: Float = 1f,
)

interface VoicePlayer {
    val state: StateFlow<VoicePlaybackState>
    fun toggle(messageId: String, url: String, durationMs: Long)
    fun seekTo(messageId: String, positionMs: Long)
    fun cycleSpeed(messageId: String)
    fun stop()
}
